var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDeveloper48Line = function SvgIconDeveloper48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 9.3H14.6a5.31 5.31 0 0 0-5.3 5.3v12.8c0 2.92 2.38 5.3 5.3 5.3h7.6v2.6H18v3.4h12v-3.4h-4.2v-2.6h7.6c2.92 0 5.3-2.38 5.3-5.3V14.6c0-2.92-2.38-5.3-5.3-5.3Zm1.9 18.1a1.9 1.9 0 0 1-1.9 1.9H14.6a1.9 1.9 0 0 1-1.9-1.9V14.6c0-1.05.85-1.9 1.9-1.9h18.8c1.05 0 1.9.85 1.9 1.9v12.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.19 15.77-3.63 3.46c-.48.46-.76 1.11-.76 1.77 0 .66.28 1.32.76 1.78l3.63 3.46 2.34-2.46-2.91-2.77 2.91-2.77-2.34-2.46v-.01ZM28.81 15.77l-2.34 2.46L29.38 21l-2.91 2.77 2.34 2.46 3.63-3.46c.48-.46.76-1.11.76-1.78 0-.67-.28-1.32-.76-1.77l-3.63-3.46v.01Z",
    fill: "current"
  })));
};
export default SvgIconDeveloper48Line;